import { connect } from "react-redux"

import { setIdentityConsent } from "../store/survey.actions"
import { getConsentIsAnonymous, getOptionalUserEmail, getRequiresCode } from "../store/survey.selectors"

const mapState = state => ({
  isCodeRequired: getRequiresCode(state),
  consentIsAnonymous: getConsentIsAnonymous(state),
  optionalUserEmail: getOptionalUserEmail(state)
})

const mapDispatch = dispatch => ({
  setIdentityConsent: payload => dispatch(setIdentityConsent(payload))
})

const optionalIdentityConsentContainer = connect(mapState, mapDispatch)

export default optionalIdentityConsentContainer
